import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./styles.css";
import Image from "../../components/Image";
import {
    checkAndSetStats,
    isMobileUserAgent,
    scrollToElement,
} from "../../helpers/helpers";
import billionBlurred from "../../images/billionBlurred.png";
import { Button } from "primereact/button";
import ParallaxImage from "../../components/ParallaxImage";
import MovingComponent from "../../components/MovingComponent";
import InfiniteCarousel from "../../components/InfiniteCarousel";
import ContactMeBlock from "../../components/ContactMeBlock";
import { get, ref } from "firebase/database";
import { database } from "../../firebase";
import OrderBlock from "../../components/OrderBlock";
import { Sidebar } from "primereact/sidebar";
import SizeSidebar from "../../components/SizeSidebar";
import { useNavigate } from "react-router-dom";
import ProductLuxury from "../../components/ProductLuxury";
import Navigation from "../../components/Navigation";
import SEO from "../../components/SEO";

function Billion() {
    const navigate = useNavigate();
    const doesStatsSent = useRef(false);
    const isMobile = isMobileUserAgent();
    const [isLoading, setIsLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [imagesList, setImagesList] = useState(null);
    const [contactVisible, setContactVisible] = useState(false);
    const [isOrderVisible, setIsOrderVisible] = useState(false);
    const [isSizeVisible, setIsSizeVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#131213";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        const dbRefBillion = ref(database, `/BILLION/products`);
        const dbRefImagesBillion = ref(database, `/BILLION/images`);

        get(dbRefBillion)
            .then((snapshot) => {
                if (snapshot.exists()) {
                    setProducts(snapshot.val());
                } else {
                    console.log("No data available");
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => setIsLoading(false));

        get(dbRefImagesBillion).then((snapshot) => {
            if (snapshot.exists()) {
                setImagesList(snapshot.val());
            } else {
                console.log("No data available");
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("billionPage");
            doesStatsSent.current = true;
        }
    }, []);

    const getDefaultImage = (image) => {
        return imagesList ? image : billionBlurred;
    };

    return (
        <div
            className={`flex justify-center flex-col bg-diamondsBg cursor-default`}
        >
            <SEO
                title="Колекція BILLION — Натуральні діаманти"
                description="BILLION — ексклюзивна колекція прикрас з натуральними діамантами від TSATSKY. Каблучки та сережки з діамантами, що формувалися мільярди років."
                url="/billion"
                collection={{ name: "BILLION", description: "Ексклюзивна колекція прикрас з натуральними діамантами" }}
            />
            <Navigation showBack backTo="/" variant="dark" />
            <div className="flex justify-center flex-col w-fit lg:w-full mb-12 px-6 xl:px-24 pt-14 xl:pt-36 gap-0 lg:gap-7 text-[#A7A7A4]">
                <div className="flex justify-center flex-col lg:flex-row">
                    <div className="flex justify-center lg:justify-start flex-col lg:w-1/2 w-full">
                        <div className="text-xs">
                            Відкрийте для себе красу колекції BILLION
                        </div>
                        <div className="mt-6">
                            <span className="text-[32px] lg:text-[90px] text-white font-semibold font-sans leading-10 lg:leading-[90px]">
                                {isMobile
                                    ? "Яскрава історія: натуральні діаманти від TSATSKY"
                                    : "Колекція BILLION від TSATSKY"}
                            </span>
                        </div>
                        <div className="leading-[120%] lg:leading-8 text-justify mt-4">
                            Billion — це колекція ювелірних виробів з
                            натуральними діамантами, що мають історію, яка
                            триває мільярди років. Кожен камінь несе в собі
                            неймовірну подорож природи — від глибин Землі до
                            вашї прикраси. Це втілення вічності, майстерності та
                            природної краси, що відображає силу та неповторність
                            діамантів. Колекція для тих, хто прагне зберегти
                            частинку цієї вічної історії на все життя.
                        </div>

                        <Button
                            label="Обрати прикрасу"
                            onClick={() =>
                                scrollToElement("diamonds-catalogue")
                            }
                            className="rounded-[100px] font-semibold lg:rounded-none shadow-none mt-6 py-3 lg:py-4 px-5 lg:px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-full lg:w-fit"
                        />

                        <Button
                            label="Переглянути інші коллекції"
                            onClick={() => navigate("/")}
                            className="rounded-[100px] lg:hidden block font-semibold lg:rounded-none shadow-none mt-6 py-3 lg:py-4 px-5 lg:px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-full lg:w-fit"
                        />

                        <div className="text-xs mt-5 lg:mt-9">
                            Відсвяткуйте своє кохання з нашим сяйвом
                        </div>
                    </div>

                    <div className="flex justify-center lg:justify-end items-center lg:w-1/2 w-full h-full">
                        {isMobile ? (
                            <MovingComponent
                                startPosition={0}
                                direction="down"
                                speedFactor={1.5}
                            >
                                <img
                                    src={getDefaultImage(
                                        imagesList?.firstImage
                                    )}
                                    className="object-contain"
                                    alt="First Ring"
                                />
                            </MovingComponent>
                        ) : (
                            <ParallaxImage
                                // className=""
                                parallaxIntensity={120}
                                slideDirection="left"
                            >
                                <img
                                    src={getDefaultImage(
                                        imagesList?.firstImage
                                    )}
                                    className="object-contain"
                                    alt="First Ring"
                                />
                            </ParallaxImage>
                        )}
                    </div>
                </div>

                <div className="flex flex-col lg:flex-row justify-center items-center mt-10 lg:mt-[100px] gap-[10%]">
                    <div className="flex justify-center lg:w-1/2 w-full mt-5 lg:mt-0 h-full">
                        {isMobile ? (
                            <MovingComponent
                                startPosition={0}
                                speedFactor={1.5}
                            >
                                <img
                                    src={getDefaultImage(
                                        imagesList?.secondImage
                                    )}
                                    className="object-contain"
                                    alt="Second Ring"
                                />
                            </MovingComponent>
                        ) : (
                            <ParallaxImage
                                // className="shadow-2xl"
                                parallaxIntensity={120}
                                slideDirection="right"
                            >
                                <img
                                    src={getDefaultImage(
                                        imagesList?.secondImage
                                    )}
                                    className="object-contain"
                                    alt="Second Ring"
                                />
                            </ParallaxImage>
                        )}
                    </div>

                    <div className="flex justify-center flex-col lg:w-1/2 w-full">
                        <div className="mt-5 lg:mt-0">
                            <span className="text-[39px] lg:text-[54px] text-white font-semibold font-sans leading-[60px]">
                                Чому обирають діаманти BILLION?
                            </span>
                        </div>
                        <div className="leading-8 text-justify mt-4">
                            <ul class="benefits-list-billion text-left">
                                <li>
                                    <span class="benefit-title">
                                        Справжність
                                    </span>
                                    <span class="benefit-description">
                                        Тільки натуральні діаманти, сформовані
                                        природою мільярди років тому — справжні,
                                        без компромісів.
                                    </span>
                                </li>
                                <li>
                                    <span class="benefit-title">
                                        Наслідність
                                    </span>
                                    <span class="benefit-description">
                                        Ці камені — як частинка вічності, що
                                        переходить із покоління в покоління,
                                        зберігаючи цінність та сенс.
                                    </span>
                                </li>
                                <li>
                                    <span class="benefit-title">
                                        Унікальність
                                    </span>
                                    <span class="benefit-description">
                                        Жоден діамант не повторюється. Кожен має
                                        свою структуру, вкраплення та оптичні
                                        властивості — як відбиток пальця, тільки
                                        ваш.
                                    </span>
                                </li>
                                <li>
                                    <span class="benefit-title">Вічність</span>
                                    <span class="benefit-description">
                                        Колекція BILLION — це про позачасовість.
                                        Про красу, яка не старіє, і якість, що
                                        зберігається назавжди.
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <div className="mt-5 lg:mt-0 mb-8 lg flex gap-4">
                            <Button
                                label="Переглянути каталог"
                                onClick={() =>
                                    scrollToElement("diamonds-catalogue")
                                }
                                className="rounded-[100px] shadow-none mt-0 lg:mt-6 font-semibold lg:rounded-none py-4 px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-fit"
                            />
                            <Button
                                label="Визначити розмір"
                                onClick={() => setIsSizeVisible(true)}
                                className="rounded-[100px] shadow-none mt-0 lg:mt-6 font-semibold lg:rounded-none py-4 px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-fit"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-center items-center flex-col gap-3 font-sans py-10 bg-white">
                <div className="text-xs text-[#A7A7A4]">
                    Ознайомтесь з нашим каталогом
                </div>
                <div className="text-[32px] lg:text-[53px] leading-[120%] text-center font-semibold">
                    Відкрийте для себе колекцію Billion
                </div>
                <div className="text-xs">
                    Перегляньте нашу колекцію з натуральних діамантів
                </div>
            </div>

            <div
                className="text-[#A7A7A4] flex flex-col items-center lg:flex-row"
                id="info"
            >
                <div className="flex justify-center items-center flex-col w-full lg:w-1/2 py-4">
                    <div className="max-w-[433px] py-10 px-5 lg:py-0 lg:px-0">
                        <div className="text-xs">Вічна вишуканість</div>
                        <div className="mt-5 lg:mt-5">
                            <span className="text-[39px] lg:text-[54px] text-white font-semibold font-sans leading-[60px]">
                                Що таке діаманти BILLION?
                            </span>
                        </div>
                        <div className="leading-8 text-justify mt-5">
                            Діаманти BILLION — це натуральні дорогоцінні камені,
                            які формувалися в надрах Землі протягом мільярдів
                            років під впливом екстремального тиску та
                            температури. Кожен такий діамант є унікальним
                            витвором природи — з неповторною структурою,
                            вкрапленнями та оптичними характеристиками. Це не
                            просто камінь, а історія, яку можна носити. BILLION
                            — це дотик до вічності, збережений у прикрасі.
                        </div>

                        <div className="mt-4 lg:mt-10 lg flex gap-4">
                            <Button
                                onClick={() =>
                                    scrollToElement("diamonds-catalogue")
                                }
                                label="Перейти до каталогу"
                                className="rounded-[100px] shadow-none mt-0 lg:mt-6 font-semibold py-2.5 lg:py-4 px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-fit"
                            />
                            <Button
                                onClick={() =>
                                    scrollToElement("diamonds-catalogue")
                                }
                                label="Купити зараз"
                                className="rounded-[100px] mt-0 lg:mt-6 shadow-none font-semibold py-2.5 lg:py-4 px-6 border border-[#A7A7A4] hover:bg-white hover:text-black w-fit"
                            />
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-1/2">
                    <Image
                        highQualitySrc={getDefaultImage(
                            imagesList?.whatIsRightImage
                        )}
                        // lowQualitySrc={historyItem?.imageLow}
                        alt="Third Ring"
                    />
                </div>
            </div>
            <div
                className="diamonds_separator bg-center bg-cover flex justify-center font-sans p-4 lg:p-0"
                style={{
                    backgroundImage: imagesList?.personBackgroundImage
                        ? `url(${imagesList?.personBackgroundImage})`
                        : "none",
                }}
            >
                <div className="max-w-[525px] mt-32 mb-20 flex flex-col justify-center items-center">
                    <div className="mt-5 lg:mt-5 text-center">
                        <span className="text-[39px] lg:text-[54px] text-white font-semibold font-sans leading-[60px]">
                            Досконалість у деталях
                        </span>
                    </div>

                    <div className="leading-8 mt-6 text-white text-center font-extralight">
                        Відкрийте для себе силу природи й справжню вічність у
                        прикрасах BILLION — з натуральними діамантами, що
                        формувалися мільярди років. Унікальна краса, глибокий
                        сенс і розкіш, яку неможливо підробити. Прикраси,
                        створені залишити слід в історії.
                    </div>

                    <Button
                        label="Переглянути колекцію"
                        onClick={() => scrollToElement("diamonds-catalogue")}
                        className="rounded-[100px] shadow-none mt-8 py-4 px-6 border hover:shadow-lg shadow-black bg-white text-[#8D8C8C] hover:text-black w-fit"
                    />
                </div>
            </div>
            <div className="bg-white flex flex-col items-center font-sans text-[#868486]">
                <div className="text-center mt-16">
                    <div className="text-xs">Сяючий блиск</div>
                    <div className="mt-2 lg:mt-2">
                        <span className="text-[39px] lg:text-[54px] text-black font-semibold font-sans leading-[60px]">
                            Дізнайся ще більше про колекцію Billion
                        </span>
                    </div>
                    <div className="leading-8 mt-4 text-center font-extralight">
                        Зроби крок у сучасність разом з нами
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-24 p-4 lg:p-0">
                    {[
                        {
                            title: "Діамант з характером",
                            buttonTitle: "Замовити зараз",
                            onClick: () =>
                                scrollToElement("diamonds-catalogue"),
                            description:
                                "Кожен камінь у колекції BILLION — унікальний. Неповторні вкраплення, глибина кольору, природна структура — це не штамп, а витвір природи, що не має аналогів.",
                        },
                        {
                            title: "Прикраса, що має цінність у часі",
                            buttonTitle: "Замовити консультацію",
                            onClick: () => setContactVisible(true),
                            description:
                                "BILLION — це не просто аксесуар, це частина спадку. Прикраса, яку хочеться передавати з покоління в покоління, зберігаючи історії й почуття.",
                        },
                        {
                            title: "Стиль, що говорить без слів",
                            buttonTitle: "Визначити розмір",
                            onClick: () => setIsSizeVisible(true),
                            description:
                                "Обираючи BILLION, ви обираєте природність, класику і силу. Це вибір тих, хто не женеться за модою — а створює її. Прикраса, що стане продовженням вашої особистості.",
                        },
                    ].map((item) => (
                        <div className="flex flex-col justify-center items-center text-center mt-11 min-w-[300px]">
                            <div>
                                <span className="text-[34px] text-black font-semibold">
                                    {item.title}
                                </span>
                            </div>
                            <div className="text-[#A3A1A5] w-full lg:w-[300px] mt-4 min-h-[195px]">
                                {item.description}
                            </div>
                            <Button
                                label={item.buttonTitle}
                                onClick={() => item.onClick()}
                                className="rounded-none shadow-none lg:rounded-[100px] mt-6 py-2 lg:py-4 px-6 hover:shadow-lg shadow-black bg-black text-[#DCDCDB] hover:text-white w-full lg:w-fit"
                            />
                        </div>
                    ))}
                </div>
                <div className="my-8 lg:my-28">
                    <InfiniteCarousel
                        imageUrl={getDefaultImage(imagesList?.carouselUrl)}
                    />
                </div>
            </div>

            <div>
                <div className="grid grid-cols-1 md:grid-cols-2 overflow-hidden relative">
                    <ParallaxImage
                        parallaxIntensity={600}
                        slideDirection="right"
                        startFromZero
                    >
                        <div className="relative z-10">
                            <div className="absolute z-10 bottom-12 w-full">
                                <div className="w-full flex flex-col text-left mx-8 lg:mx-[10%]">
                                    <div className="text-xs text-[#B7B4B0]">
                                        Незаперечна краса
                                    </div>
                                    <div className="mt-0 lg:mt-4">
                                        <span className="text-[39px] lg:text-[54px] text-white font-semibold font-sans leading-[60px]">
                                            Вишуканий стиль
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <Image
                                highQualitySrc={getDefaultImage(
                                    imagesList?.movingImageLeft
                                )}
                                // lowQualitySrc={historyItem?.imageLow}
                                alt="Ring Four"
                            />
                        </div>
                    </ParallaxImage>
                    <div className="text-white font-sans text-center absolute w-full p-12 top-64 z-0 text-xl font-bold">
                        Подаруй диво СВОЇМ
                    </div>
                    <ParallaxImage
                        parallaxIntensity={600}
                        slideDirection="left"
                        startFromZero
                    >
                        <div className="relative z-10">
                            <Image
                                highQualitySrc={getDefaultImage(
                                    imagesList?.movingImageRight
                                )}
                                // lowQualitySrc={historyItem?.imageLow}
                                alt="Ring Five"
                            />
                        </div>
                    </ParallaxImage>

                    <div className="text-white text-center absolute w-full bottom-16 z-0 p-12 text-xl font-bold">
                        Переглянь каталог та обери прикрасу, яка розповість про
                        почуття.<br></br>{" "}
                        <div className="mt-4 text-3xl">❤️</div>
                    </div>
                </div>
            </div>

            <div className="bg-white flex flex-col items-center font-sans text-[#868486]">
                <div className="text-center mt-16 mb-10">
                    <div className="text-xs">Виділяйся серед інших</div>
                    <div className="mt-2 lg:mt-2">
                        <span className="text-[39px] lg:text-[54px] text-black font-semibold font-sans leading-[60px]">
                            Відчуй якість прикрас на собі
                        </span>
                    </div>
                    <div className="leading-8 mt-4 text-center font-extralight">
                        Вишуканість у кожній деталі
                    </div>
                </div>
            </div>

            <div>
                {isLoading ? (
                    <div className="w-full text-center text-white py-4">
                        Loading...
                    </div>
                ) : (
                    <div
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-10 sm:gap-24 p-4 lg:py-0 lg:px-10"
                        id="diamonds-catalogue"
                    >
                        {products.map((item, index) => (
                            <ProductLuxury
                                key={index}
                                item={item}
                                onButtonClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedItem(item);
                                    setIsOrderVisible(true);
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>
            <Sidebar
                className={isMobile ? "" : "w-1/2"}
                position="right"
                visible={contactVisible}
                onHide={() => setContactVisible(false)}
                fullScreen={isMobile}
            >
                <ContactMeBlock />
            </Sidebar>

            <Sidebar
                className={isMobile ? "" : "w-1/2"}
                position="right"
                visible={isOrderVisible}
                onHide={() => setIsOrderVisible(false)}
                fullScreen={isMobile}
            >
                <OrderBlock product={selectedItem} />
            </Sidebar>

            <SizeSidebar
                isVisible={isSizeVisible}
                setIsVisible={setIsSizeVisible}
            />
        </div>
    );
}

export default Billion;
